export const strTransArr = (str: string) => {
  if (!str) return undefined;
  return str
    ?.split(/\//)
    ?.filter((item) => item)
    ?.map((str: string) => Number(str));
};
